import { render, staticRenderFns } from "./SetupNewPassword.vue?vue&type=template&id=7e8f09b0"
import script from "./SetupNewPassword.vue?vue&type=script&lang=ts"
export * from "./SetupNewPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports